import { render, staticRenderFns } from "./InfoEdit.vue?vue&type=template&id=8300de6a"
import script from "./InfoEdit.vue?vue&type=script&lang=js"
export * from "./InfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports